module.exports = __webpack_public_path__ + "static/img/PSD16-S.89a5e91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/PSD16-S.png
// module id = 8f93
// module chunks = 1